/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {DevilsCrossRoadGameAssets} from "./DevilsCrossRoadGameAssets";
import {DevilsCrossRoadSound} from "./sound/DevilsCrossRoadSound";
import {DevilsCrossRoadLayers} from "./view/DevilsCrossRoadLayers";
import {DevilsCrossRoadFreespinIdlePresentation} from "./gameflow/freespin/DevilsCrossRoadFreespinIdlePresentation";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {DevilsCrossRoadGameMode} from "./server/DevilsCrossRoadGameMode";
import {RestoreUtils} from "./utils/RestoreUtils";
import {DCRoadModel} from "./server/data/DCRoadModel";
import {DCRoadNormalBetPresentation} from "./gameflow/normal/DCRoadNormalBetPresentation";
import {DCRoadNormalIdlePresentation} from "./gameflow/normal/DCRoadNormalIdlePresentation";
import {DCRoadBackgroundElements} from "./view/DCRoadBackgroundElements";
import {ReelFrameView} from "./view/ReelFrameView";
import {DCRoadNormalResultPresentation} from "./gameflow/normal/DCRoadNormalResultPresentation";
import {DCRoadNormalWinPresentation} from "./gameflow/normal/DCRoadNormalWinPresentation";
import {DCRoadAvalancheIdlePresentation} from "./gameflow/avalanche/DCRoadAvalancheIdlePresentation";
import {DevilsCrossroadFreespinReelAreaView} from "./reelsfs/DevilsCrossroadFreespinReelAreaView";
import {DevilsCrossroadFreespinZeroBet} from "./gameflow/freespin/DevilsCrossroadFreespinZeroBet";
import {DevilsCrossRoadFreespinResult} from "./gameflow/freespin/DevilsCrossroadFreespinResult";
import {TransitionScreenView} from "./view/TransitionScreenView";
import {DevilsCrossroadFreespinWin} from "./gameflow/freespin/DevilsCrossroadFreespinWin";
import {DevilsCrossroadSfsIdle} from "./gameflow/superfreespin/DevilsCrossroadSfsIdle";
import {FreespinMultiplicatorView} from "./view/FreespinMultiplicatorView";
import {FreespinUnlockableAreasView} from "./view/FreespinUnlockableAreasView";
import {FreespinCollectorView} from "./view/FreespinCollectorView";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {DCRoadReelsController} from "./reels/DCRoadReelsController";
import {ReelStopPresentationManager} from "./reelstoppresentation/ReelStopPresentationManager";
import {WinPresentationManager} from "./winpresentation/WinPresentationManager";
import {InitialWinController} from "./winpresentation/presentations/initial/InitialWinController";
import {TotalWinCountUp} from "./winpresentation/presentations/initial/TotalWinCountUp";
import {TotalWinController} from "./winpresentation/presentations/initial/TotalWinController";
import {BigWinCountUp} from "./winpresentation/presentations/bigwin/BigWinCountUp";
import {BigWinController} from "./winpresentation/presentations/bigwin/BigWinController";
import {AvalancheController} from "./winpresentation/presentations/AvalancheController";
import {DCRoadAvalancheBetPresentation} from "./gameflow/avalanche/DCRoadAvalancheBetPresentation";
import {MainGameMultipliers} from "./view/MainGameMultipliers";
import {ScatterLandingController} from "./reelstoppresentation/presentations/ScatterLandingController";
import {ForbidSymbolsController} from "./winpresentation/presentations/ForbidSymbolsController";
import {FreespinWinController} from "./winpresentation/presentations/FreespinWinController";
import {DevilView} from "./view/DevilView";
import {CashGameFeatureHandler} from "./runnerpresentations/freespin/cashgamefeatures/CashGameFeatureHandler";
import {RandomWildsController} from "./winpresentation/presentations/RandomWildsController";
import {EndBonusView} from "./view/EndBonusView";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {ISymbolValues} from "./server/data/DCRoadData";
import {SymbolLandingController} from "./reelstoppresentation/presentations/SymbolLandingController";
import {
    EndBonusPreBWController
} from "./winpresentation/presentations/bigwin/EndBonusPreBWController";
import {InitialMultipliersController} from "./winpresentation/presentations/InitialMultipliersController";
import {RemoveWinSymbolsController} from "./winpresentation/presentations/RemoveWinSymbolsController";
import {BigWinView} from "./winpresentation/presentations/bigwin/BigWinView";
import {WinCapScreen} from "./view/WinCapScreen";
import {BrokeTheBankController} from "./winpresentation/presentations/BrokeTheBankController";
import {IdleAnimationManager} from "./idle/IdleAnimationManager";
import {MainFrameIdleController} from "./idle/animations/MainFrameIdleController";
import {PreBigWinController} from "./winpresentation/presentations/bigwin/PreBigWinController";

export class DevilsCrossRoad extends SlotGame {
    public static model:DCRoadModel;
    public static gameFlowController:GameFlowController;
    public static assetLoader:AssetLoader;

    public static reels:DCRoadReelsController;
    public static multipliers:MainGameMultipliers;
    public static devil:DevilView;
    public static symbolLanding:SymbolLandingController;
    public static scatters:ScatterLandingController;
    public static reelStopPresentations:ReelStopPresentationManager;
    public static forbiddenSymbols:ForbidSymbolsController;
    public static initialMultipliers:InitialMultipliersController;
    public static removeSymbols:RemoveWinSymbolsController;
    public static winPresentations:WinPresentationManager;
    public static endBonusWinPresentations:WinPresentationManager;
    public static totalWinCountUp:TotalWinCountUp;
    public static bigWinCountUp:BigWinCountUp;
    public static idle:IdleAnimationManager;

    public static backgroundElements:DCRoadBackgroundElements;
    public static reelFrameView:ReelFrameView;
    public static freespinReelAreaView:DevilsCrossroadFreespinReelAreaView;
    public static transitionScreenView:TransitionScreenView;
    public static freespinMpView:FreespinMultiplicatorView;
    public static freespinUnlockAreas:FreespinUnlockableAreasView;
    public static freespinCollectorView:FreespinCollectorView;
    public static cashFeatureHandler:CashGameFeatureHandler;
    public static endBonusView:EndBonusView;
    public static bigwinView:BigWinView;
    public static wincapScreen:WinCapScreen;

    // TODO: Move to fs view?
    public static LANDED_STICKYS_IDS:number [] = [];

    // 0-5 = feature row, except i: 5 (dead)
    // 6 - 11
    // 11-16
    // 17 - 22
    // 23 - 28
    // 29 - 34
    public static STICKY_COLUMN_RIDS:number [][] = [
        [1, 2, 3, 4, 5], // Row 1
        [7, 8, 9, 10, 11], // Row 2
        [13, 14, 15, 16, 17], // Row 3
        [19, 20, 21, 22, 23], // Row 4
        [25, 26, 27, 28, 29], // Row 5
    ];

    public static STICKY_ROW_RIDS:number [][] = [];

    private _defaultSymbolValues:ISymbolValues = {
        "L1" : {3 : 6, 4 : 12, 5 : 24},
        "L2" : {3 : 5, 4 : 10, 5 : 20},
        "L3" : {3 : 4, 4 : 8, 5 : 16},
        "L4" : {3 : 3, 4 : 6, 5 : 12},
        "L5" : {3 : 2, 4 : 4, 5 : 8},
        "M1" : {3 : 50, 4 : 100, 5 : 200},
        "M2" : {3 : 30, 4 : 60, 5 : 120},
        "M3" : {3 : 20, 4 : 40, 5 : 80},
        "M4" : {3 : 15, 4 : 30, 5 : 60},
        "M5" : {3 : 10, 4 : 20, 5 : 40}
    }

    constructor() {
        super();
    }

    public async init():Promise<NolimitPlugin> {
        const value = await super.init();

        if(NolimitConfig.isDevMode) {
            (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
        }

        DevilsCrossRoad.model = new DCRoadModel(SlotGame.apiPlugin, true);
        DevilsCrossRoad.gameFlowController = new GameFlowController(SlotGame.apiPlugin, DevilsCrossRoad.model);
        DevilsCrossRoad.gameFlowController.flowStateLogger.level = LogLevel.DEV;

        const normalIdle = new DCRoadNormalIdlePresentation();
        const normalBet = new DCRoadNormalBetPresentation();
        const normalResult = new DCRoadNormalResultPresentation();
        const normalWin = new DCRoadNormalWinPresentation();
        const avalancheIdle = new DCRoadAvalancheIdlePresentation();
        const avalancheBet = new DCRoadAvalancheBetPresentation();
        // const avalancheFillUpReels = new CrossReelAvalancheFillUpPresentation();

        const freespinIdle = new DevilsCrossRoadFreespinIdlePresentation(); // TODO: no need to alter?
        const freespinZeroBet = new DevilsCrossroadFreespinZeroBet();
        const freespinResult = new DevilsCrossRoadFreespinResult();
        const freespinWin = new DevilsCrossroadFreespinWin();

        // Sfs
        const sfsIdle = new DevilsCrossroadSfsIdle();
        const sfsWin = new DevilsCrossroadFreespinWin();

        DevilsCrossRoad.gameFlowController.addGameModeFlowStatePresentationMap(DevilsCrossRoadGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, normalIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, normalWin]
        ]));

        DevilsCrossRoad.gameFlowController.addGameModeFlowStatePresentationMap(DevilsCrossRoadGameMode.NORMAL_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, avalancheIdle],
            [FlowState.BET, avalancheBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, normalWin]
        ]));

        DevilsCrossRoad.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, freespinZeroBet],
            [FlowState.RESULT, freespinResult],
            [FlowState.WIN, freespinWin]
        ]))

        DevilsCrossRoad.gameFlowController.addGameModeFlowStatePresentationMap(DevilsCrossRoadGameMode.SUPER_FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, sfsIdle],
            [FlowState.BET, freespinZeroBet],
            [FlowState.RESULT, freespinResult],
            [FlowState.WIN, sfsWin]
        ]));
        return value;
    }

    public async getReady():Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value = await super.getReady();

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);

        AssetsConfig.addToAssetsConfig(DevilsCrossRoadGameAssets.RESOURCES_GROUPS);
        DevilsCrossRoad.assetLoader = new AssetLoader(DevilsCrossRoad.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        const promises = Promise.all([fontLoader.load(), DevilsCrossRoad.assetLoader.load(ResourcesGroupName.MAIN)]);

        return promises.then((values:any) => {
            this.createViewsAndComponents();
            return value;
        });
    }

    public async getReadyToStart():Promise<NolimitPlugin> {
        //Game assets loaded, showing intro, waiting for user to start game.
        DevilsCrossRoadSound.switchMusic(
            {name : DevilsCrossRoadSound.MAIN_GAME_MUSIC, volume : 0},
            {name : DevilsCrossRoadSound.MAIN_GAME_MUSIC, from : 0, to : 1, duration : 1000}
        );
        return await super.getReadyToStart();
    }

    public async start():Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.

        const value = await super.start();

        DevilsCrossRoad.gameFlowController.start();
        DevilsCrossRoadSound.switchMusic({name : DevilsCrossRoadSound.getMusicNameByMode(DevilsCrossRoad.model.data.mode)});

        return value;
    }

    public getPaytable():Promise<string> {
        const templateLoader:TemplateLoader = new TemplateLoader(DevilsCrossRoad.apiPlugin.resources.getStaticRoot());

        templateLoader.add({
            name : "Paytable",
            url : "nolimit/screens/paytable.mustache"
        });

        let symbolDataValueData:ISymbolValues = this._defaultSymbolValues;
        if(DevilsCrossRoad.model.initData.symbolValues) {
            symbolDataValueData = DevilsCrossRoad.model.initData.symbolValues;
            //console.log("Using symbolValues from INIT data");
        } else {
            //console.log("Using default symbolValues ");
        }

        return templateLoader.load().then((assets:TemplateAsset[]) => {
            for(let asset of assets) {
                if(asset.name === "Paytable" && asset.loadedData) {
                    for(let key in symbolDataValueData) {
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, DevilsCrossRoad.getSymbolString(key, symbolDataValueData[key]))
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("DevilsCrossRoad could not load Paytable");
        });
    }

    private static getSymbolString(key:string, data:{ [numSymbols:number]:number }):string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    private createViewsAndComponents() {
        //Non views
        const sound = new DevilsCrossRoadSound();
        const layers = new DevilsCrossRoadLayers();

        //Views
        DevilsCrossRoad.backgroundElements = new DCRoadBackgroundElements();
        DevilsCrossRoad.freespinReelAreaView = new DevilsCrossroadFreespinReelAreaView();
        DevilsCrossRoad.reelFrameView = new ReelFrameView();
        DevilsCrossRoad.freespinUnlockAreas = new FreespinUnlockableAreasView();

        DevilsCrossRoad.totalWinCountUp = new TotalWinCountUp();
        DevilsCrossRoad.bigWinCountUp = new BigWinCountUp();
        DevilsCrossRoad.symbolLanding = new SymbolLandingController();
        DevilsCrossRoad.scatters = new ScatterLandingController();
        DevilsCrossRoad.multipliers = new MainGameMultipliers();
        DevilsCrossRoad.reels = new DCRoadReelsController();
        DevilsCrossRoad.devil = new DevilView();
        DevilsCrossRoad.reelStopPresentations = new ReelStopPresentationManager([
            DevilsCrossRoad.symbolLanding,
            DevilsCrossRoad.scatters
        ]);
        DevilsCrossRoad.forbiddenSymbols = new ForbidSymbolsController();
        DevilsCrossRoad.initialMultipliers = new InitialMultipliersController();
        DevilsCrossRoad.removeSymbols = new RemoveWinSymbolsController();
        DevilsCrossRoad.winPresentations = new WinPresentationManager([
            new RandomWildsController(),
            new InitialWinController(),
            DevilsCrossRoad.forbiddenSymbols,
            DevilsCrossRoad.initialMultipliers,
            DevilsCrossRoad.removeSymbols,
            new AvalancheController(),
            new FreespinWinController(),
            new TotalWinController(),
            new PreBigWinController(),
            new BigWinController(),
            new BrokeTheBankController()
        ]);
        DevilsCrossRoad.endBonusWinPresentations = new WinPresentationManager([
            new EndBonusPreBWController(),
            new BigWinController(),
        ]);

        DevilsCrossRoad.reelFrameView.switchReelFrame(DevilsCrossRoad.model.data.mode);
        DevilsCrossRoad.freespinReelAreaView.switchReelMode(DevilsCrossRoad.model.data.mode);
        DevilsCrossRoad.freespinReelAreaView.initReels();
        DevilsCrossRoad.transitionScreenView = new TransitionScreenView();
        DevilsCrossRoad.freespinMpView = new FreespinMultiplicatorView();
        DevilsCrossRoad.freespinCollectorView = new FreespinCollectorView();
        DevilsCrossRoad.cashFeatureHandler = new CashGameFeatureHandler();
        DevilsCrossRoad.endBonusView = new EndBonusView();
        DevilsCrossRoad.bigwinView = new BigWinView();
        DevilsCrossRoad.wincapScreen = new WinCapScreen();
        DevilsCrossRoad.idle = new IdleAnimationManager([
            new MainFrameIdleController()
        ]);

        NolimitApplication.addLayerAt(DevilsCrossRoad.endBonusView.name, DevilsCrossRoad.endBonusView);
        NolimitApplication.addLayerAt(DevilsCrossRoad.freespinMpView.name, DevilsCrossRoad.freespinMpView, 0);
        NolimitApplication.addLayerAt(DevilsCrossRoad.freespinCollectorView.name, DevilsCrossRoad.freespinCollectorView, 0);
        NolimitApplication.addLayerAt(DevilsCrossRoad.freespinUnlockAreas.name, DevilsCrossRoad.freespinUnlockAreas, 0);
        NolimitApplication.addLayerAt(DevilsCrossRoad.freespinReelAreaView.name, DevilsCrossRoad.freespinReelAreaView, 0);
        NolimitApplication.addLayerAt(DevilsCrossRoad.reelFrameView.name, DevilsCrossRoad.reelFrameView, 0);
        NolimitApplication.addLayerAt(DevilsCrossRoad.backgroundElements.name, DevilsCrossRoad.backgroundElements, 0);

        RestoreUtils.startupGame();
        if(DevilsCrossRoad.model.isRestore) {
            SlotGame.keypadPlugin.setWin(DevilsCrossRoad.model.data.accumulatedRoundWin, true, BelowStakeWinRestriction.isWinBelowStake());

            DevilsCrossRoad.backgroundElements.setMode(DevilsCrossRoad.model.data.mode);

            if(DevilsCrossRoad.model.data.mode === DevilsCrossRoadGameMode.FREESPIN || DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.FREESPIN) {
                //DevilsCrossRoad.reelFrameView.switchReelFrame(DevilsCrossRoadGameMode.FREESPIN);
                //DevilsCrossRoad.freespinReelAreaView.switchReelMode(DevilsCrossRoadGameMode.FREESPIN);

                const featuresActivatedTop:boolean [] = DevilsCrossRoad.model.getFeatureActivatedByArea("top");
                DevilsCrossRoad.freespinUnlockAreas.show().add(() => {
                    DevilsCrossRoad.freespinUnlockAreas.setupForRestore("top", featuresActivatedTop);
                });
                DevilsCrossRoad.freespinReelAreaView.setReelsWithData(DevilsCrossRoad.model.data.stickyCoins, DevilsCrossRoad.model.data.stickyCoinsValues);
                DevilsCrossRoad.freespinCollectorView.updateCollect(DevilsCrossRoad.model.data.collectMeter);
                DevilsCrossRoad.freespinMpView.updateMpText(DevilsCrossRoad.model.getTotalFsXwin());
                //DevilsCrossRoad.freespinUnlockAreas.setupForRestore("top", featuresActivatedTop);
            } else if(DevilsCrossRoad.model.data.mode === DevilsCrossRoadGameMode.SUPER_FREESPIN || DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.SUPER_FREESPIN) {
                //DevilsCrossRoad.reelFrameView.switchReelFrame(DevilsCrossRoadGameMode.FREESPIN_SUPER);
                //DevilsCrossRoad.freespinReelAreaView.switchReelMode(DevilsCrossRoadGameMode.FREESPIN_SUPER);

                const featuresActivatedTop:boolean [] = DevilsCrossRoad.model.getFeatureActivatedByArea("top");
                const featuresActivatedRight:boolean [] = DevilsCrossRoad.model.getFeatureActivatedByArea("right");
                DevilsCrossRoad.freespinUnlockAreas.show().add(() => {
                    DevilsCrossRoad.freespinUnlockAreas.setupForRestore("top", featuresActivatedTop);
                    DevilsCrossRoad.freespinUnlockAreas.setupForRestore("right", featuresActivatedRight);
                });
                DevilsCrossRoad.freespinReelAreaView.setReelsWithData(DevilsCrossRoad.model.data.stickyCoins, DevilsCrossRoad.model.data.stickyCoinsValues);
                DevilsCrossRoad.freespinCollectorView.updateCollect(DevilsCrossRoad.model.data.collectMeter);
                DevilsCrossRoad.freespinMpView.updateMpText(DevilsCrossRoad.model.getTotalFsXwin());

            }
        }
    }

    public getNoWinGameData():any {
        return {
            "reels" : [
                [
                    "Y",
                    "M3",
                    "M2",
                    "M2",
                    "Y"
                ],
                [
                    "M5",
                    "Y",
                    "L5",
                    "Y",
                    "M5"
                ],
                [
                    "M5",
                    "L2",
                    "D",
                    "M1",
                    "M2"
                ],
                [
                    "M5",
                    "Y",
                    "L4",
                    "Y",
                    "L5"
                ],
                [
                    "Y",
                    "M2",
                    "M2",
                    "M2",
                    "Y"
                ]
            ],
            "evaluatedArea" : [
                [
                    "Y",
                    "M3",
                    "M2",
                    "M2",
                    "Y"
                ],
                [
                    "M5",
                    "Y",
                    "L5",
                    "Y",
                    "M5"
                ],
                [
                    "M5",
                    "L2",
                    "D",
                    "M1",
                    "M2"
                ],
                [
                    "M5",
                    "Y",
                    "L4",
                    "Y",
                    "L5"
                ],
                [
                    "Y",
                    "M2",
                    "M2",
                    "M2",
                    "Y"
                ]
            ],
            "reelsAfterCollapse" : [
                [
                    "Y",
                    "M3",
                    "M2",
                    "M2",
                    "Y"
                ],
                [
                    "M5",
                    "Y",
                    "L5",
                    "Y",
                    "M5"
                ],
                [
                    "M5",
                    "L2",
                    "D",
                    "M1",
                    "M2"
                ],
                [
                    "M5",
                    "Y",
                    "L4",
                    "Y",
                    "L5"
                ],
                [
                    "Y",
                    "M2",
                    "M2",
                    "M2",
                    "Y"
                ]
            ],
            "betWayWins" : [],
            "totalSpinWinnings" : 0,
            "accumulatedRoundWin" : 0,
            "playedBetValue" : 1,
            "mode" : "NORMAL",
            "nextMode" : "NORMAL",
            "numberOfFreespinsPlayed" : 0,
            "freespinsLeft" : 0,
            "addedNumberOfFreespinsThisSpin" : 0,
            "symbolSizes" : [
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            ],
            "wasFeatureBuy" : false,
            "brokeTheBank" : false,
            "thisSpinWinning" : 0,
            "collectMeter" : 0,
            "fullScreenCoin" : false,
            "numCoins" : 0,
            "forbiddenSymbols" : [],
            "placesHandled" : [
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "quadMultiplier" : [
                1,
                1,
                1,
                1
            ],
            "nextQuadMultiplier" : [
                1,
                1,
                1,
                1
            ],
            "featuresForClient" : [],
            "outcomeSetterHandledThisSpin" : true
        }
    }
}